import { IAppState } from '../types';
import { IBooking, IBusiness, IService } from './types';

export const getBusinesses = (state: IAppState): IBusiness[] => state.api.businesses;
export const getBookings = (state: IAppState): IBooking[] => state.api.businessBookings;
export const getBusinessBookings = (state: IAppState): IBooking[] => state.api.businessBookings;
export const getSelectedServices = (state: IAppState): IService[] => state.api.selectedServices;
export const getSelectedBusiness = (state: IAppState): IBusiness | null => state.api.selectedBusiness;
